import React,{FC,useState,useEffect,useRef} from 'react';
import {useNavigate,useLocation,HashRouter,Routes,Route,useParams} from 'react-router-dom';
import logo from './logo.svg';
import { useThrottleFn } from 'ahooks'
import { Button, NavBar, TabBar,SideBar,Toast,List,SearchBar } from 'antd-mobile'
import {
  AppOutline,
  MessageOutline,
  UnorderedListOutline,
  UserOutline,LeftOutline
} from 'antd-mobile-icons'
import './App.css';
import './demo2.css'
import axios from 'axios';
import Bottom from "./Bottom";
import Prescription from "./Prescription";
import Medicine from "./Medicine";
import Unit from "./Unit";
import About from "./About";
import Diagnose from "./Diagnose";
import Part from "./Part";
import ShowItems from "./ShowItems";
import Contact from "./Contact";
const Home: FC = (props) => {
  const [tabs,setTabs]=useState([] as any);
  const [activeKey, setActiveKey] = useState('0');
  const navigate=useNavigate();
  const mainElementRef = useRef<HTMLDivElement>(null);
  const { run: handleScroll } = useThrottleFn(
      () => {
        let currentKey = tabs[0].key
        for (const item of tabs) {
          const element = document.getElementById(`anchor-${item.key}`)
          if (!element) continue
          const rect = element.getBoundingClientRect()
          console.log(rect.top+' + '+item.key);
          if (rect.top <= 47) {
            console.log('goto:'+item.key);
            currentKey = item.key
          } else {
            break
          }
        }
        setActiveKey(currentKey+'')
      },
      {
        leading: true,
        trailing: true,
        wait: 100,
      }
  )
  useEffect(()=>{
    let items=[
      {key:0,title:'自序'}
    ];

    Toast.show({icon:'loading',content:'加载中...',maskClickable: false,duration:30000});
    // @ts-ignore
    axios({
      method:'post',url:'/data/book/chapter',data:{uuid:'e938a0d811931680d0fe500c454f282f'},reponseType:'json'
    }).then(function(response){
      Toast.clear();
      let json=response.data;
      if(json.success){
        let items=[];
        let idx=0;
        let activeKey='';
        json.data.items.map(item=>{
          items.push({key:item.key,title:item.name,arts:item.arts});
          if(idx==0){
            activeKey=item.key;
          }
          idx++;
        });
        setTabs(items);
        setActiveKey(activeKey+'');
      }else{
        Toast.show({icon:'fail',content:json.message});
      }
    }).catch(function(error){
      console.log(error)
      Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
    });

    const mainElement = mainElementRef.current
    if (!mainElement) return
    mainElement.addEventListener('scroll', handleScroll)
    return () => {
      mainElement.removeEventListener('scroll', handleScroll)
    }
  },[]);
  const searchMedicine = (val:string) =>{
    Toast.show({icon:'loading',content:'搜索中...',maskClickable: false,duration:30000});
    // @ts-ignore
    axios({
      method:'post',url:'/data/book/chapter',data:{uuid:'e938a0d811931680d0fe500c454f282f',keywords:val},reponseType:'json'
    }).then(function(response){
      Toast.clear();
      let json=response.data;
      if(json.success){
        let items=[];
        let idx=0;
        let activeKey='';
        json.data.items.map(item=>{
          items.push({key:item.key,title:item.name,arts:item.arts});
          if(idx==0){
            activeKey=item.key;
          }
          idx++;
        });
        setTabs(items);
        if(items.length==0){
          Toast.show({icon:'fail',content:"未查询到相关信息，请更换搜索词后再次尝试查询"});
        }
      }else{
        Toast.show({icon:'fail',content:json.message});
      }
    }).catch(function(error){
      console.log(error)
      Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
    });
  }
  return (<div className='app'>
    <div className='top'>
      <NavBar back={null}>桂林古本-伤寒杂病论-白话注解</NavBar>
    </div>
    <div className='body'>
      <div style={{padding:'12px',backgroundColor:"#fff",textAlign:'center'}}>
        <Button size="small" onClick={()=>{ navigate("/part"); }} >条辨原文/译文检索</Button>
      </div>
      <div className="container">
        <div className="side"><SideBar activeKey={activeKey} onChange={key => {
    document.getElementById(`anchor-${key}`)?.scrollIntoView()
  }}>{tabs.map(item => (
      <SideBar.Item key={item.key} title={item.title} />
  ))}

  </SideBar></div><div className="main" ref={mainElementRef}> {tabs.map(item => (
      <div key={item.key}>
        <h2 id={`anchor-${item.key}`}>{item.title}</h2>
        <List header={false}>
          {item.arts&&item.arts.map(art => (
              <List.Item key={art.key} className='art-title' onClick={()=>{ navigate('/show/'+art.key); }}>{art.title}</List.Item>
          ))}

        </List>
      </div>
  ))}</div></div></div>
    <div className='bottom'>
      <Bottom></Bottom>
    </div>
  </div>)
}

const ShowBookArticle: FC = (props) => {
  const [art,setArt]=useState({title:'',content:''});
  let params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  console.log(location);
  useEffect(()=>{
    Toast.show({icon:'loading',content:'加载中...',maskClickable: false,duration:30000});
    // @ts-ignore
    axios({
      method:'post',url:'/data/book/show',data:{id:params.id},reponseType:'json'
    }).then(function(response){
      Toast.clear();
      let json=response.data;
      if(json.success){
        setArt(json.data.art);
      }else{
        Toast.show({icon:'fail',content:json.message});
      }
    }).catch(function(error){
      console.log(error)
      Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
    });

  },[]);
  return (<div className='app'>
    <div className='top'>
      <NavBar onBack={()=>{ navigate(-1); }}>{art.title}</NavBar>
    </div>
    <div className="body">
      <div className='art-content book-content'>
        <div dangerouslySetInnerHTML={{__html:art.content}} />
      </div>
      <div className="footer-back-icon">
        <LeftOutline style={{ fontSize: 28, color:'var(--adm-color-primary)' }} onClick={()=>{ navigate(-1); }} />
      </div>
    </div>
  </div>)
}


const App: FC = (props) => {
  const [a,setA]=useState('');

  return (
      <HashRouter >
            <Routes>
              <Route path='/' element={<Home></Home>}></Route>
              <Route path='/show/:id' element={<ShowBookArticle></ShowBookArticle>}></Route>
              <Route path='/part/items/:id' element={<ShowItems></ShowItems>}></Route>
              <Route path='/prescription' element={<Prescription/>}>
              </Route>
              <Route path='/medicine' element={<Medicine/>}>
              </Route>
              <Route path='/diagnose' element={<Diagnose/>}>
              </Route>
              <Route path='/about' element={<About/>}></Route>
              <Route path='/part' element={<Part/>}></Route>
              <Route path='/contact' element={<Contact/>}></Route>
            </Routes>
      </HashRouter>
  );
}


export default App;
